<template>
    <div class="table-cost-unit-summary">
        <b-table-simple v-if="isDataLoaded" borderless class="text-right" responsive>
            <b-tr>
                <b-td class="label"/>
                <b-td>netto/neutral</b-td>
                <b-td>Ust.</b-td>
                <b-td>Summe</b-td>
            </b-tr>
            <b-tr class="font-weight-bold">
                <b-td class="label">
                    Gesamtforderung
                </b-td>
                <b-td>{{ formatCurrency(costUnitSummary.net.amount) }}</b-td>
                <b-td>{{ formatCurrency(costUnitSummary.vat.amount) }}</b-td>
                <b-td>{{ formatCurrency(costUnitSummary.gross.amount) }}</b-td>
            </b-tr>
            <b-tr class="font-weight-bold text-success">
                <b-td class="label">
                    <span>Bereits&nbsp;gezahlt</span>
                </b-td>
                <b-td>{{ formatCurrency(costUnitSummary.net.payments) }}</b-td>
                <b-td>{{ formatCurrency(costUnitSummary.vat.payments) }}</b-td>
                <b-td>{{ formatCurrency(costUnitSummary.gross.payments) }}</b-td>
            </b-tr>
            <b-tr class="font-weight-bold">
                <b-td class="label">
                    akzept.&nbsp;Minderung
                </b-td>
                <b-td>{{ formatCurrency(costUnitSummary.net.adjustment) }}</b-td>
                <b-td>{{ formatCurrency(costUnitSummary.vat.adjustment) }}</b-td>
                <b-td>{{ formatCurrency(costUnitSummary.gross.adjustment) }}</b-td>
            </b-tr>
            <b-tr class="font-weight-bold text-danger table-last-row">
                <b-td class="label">
                    Offene&nbsp;Forderung
                </b-td>
                <b-td>{{ formatCurrency(costUnitSummary.net.open) }}</b-td>
                <b-td>{{ formatCurrency(costUnitSummary.vat.open) }}</b-td>
                <b-td>{{ formatCurrency(costUnitSummary.gross.open) }}</b-td>
            </b-tr>
        </b-table-simple>
    </div>
</template>

<script>

    import {formatCurrency} from '@js/functions/format';

    export default {
        props: {
            costUnitSummary: {
                type: Object,
                required: true,
            },
        },
        computed: {
            isDataLoaded() {
                return this.costUnitSummary.net && this.costUnitSummary.gross && this.costUnitSummary.vat;
            },
        },
        methods: {formatCurrency},
    }
</script>
